// contentful.js

import { createClient } from "contentful";

// Validate required environment variables
const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_ACCESS_TOKEN;

if (!spaceId || !accessToken) {
  console.error("Missing required Contentful credentials. Please check your .env file.");
  throw new Error("Missing required Contentful credentials. Please check your .env file.");
}

const client = createClient({
  space: spaceId,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || "master",
  accessToken: accessToken,
});

export const fetchProducts = async (contentType = "cleaningProductData") => {
  try {
    console.log(`Fetching products for content type: ${contentType}`);
    const response = await client.getEntries({ 
      content_type: contentType,
      order: 'fields.productTitle' // Optional: order by product title
    });
    
    if (!response.items || response.items.length === 0) {
      console.warn(`No products found for content type: ${contentType}`);
      return [];
    }
    
    console.log(`Successfully fetched ${response.items.length} products for ${contentType}`);
    return response.items;
  } catch (error) {
    console.error(`Error fetching products for ${contentType}:`, error);
    if (error.status === 404) {
      console.error("Contentful space not found. Please verify your Space ID and Access Token.");
    } else if (error.status === 401) {
      console.error("Unauthorized. Please verify your Access Token.");
    } else if (error.status === 400) {
      console.error("Invalid content type. Please verify the content type exists in your Contentful space.");
    }
    return []; // Return empty array instead of throwing error
  }
};

export const fetchProductByTitle = async (productTitle, contentType) => {
  try {
    // Convert URL-friendly title back to normal title
    const searchTitle = productTitle.replace(/-/g, ' ');
    
    const response = await client.getEntries({ 
      content_type: contentType,
      'fields.productTitle[match]': searchTitle
    });
    
    if (response.items && response.items.length > 0) {
      return response.items[0];
    }
    return null;
  } catch (error) {
    console.error('Error fetching product by title:', error);
    throw error;
  }
};

export const fetchProductById = async (productId, contentType) => {
  try {
    const response = await client.getEntry(productId);
    return response;
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    throw error;
  }
};

export const fetchB2BProducts = async () => {
  try {
    const response = await client.getEntries({ content_type: "b2bCleaningProductData" });
    return response.items;
  } catch (error) {
    console.error("Error fetching B2B products:", error);
    if (error.status === 404) {
      console.error("Contentful space not found. Please verify your Space ID and Access Token.");
    } else if (error.status === 401) {
      console.error("Unauthorized. Please verify your Access Token.");
    }
    throw error;
  }
};

export default client;
